import React from "react";
import ResponsiveImage from "./ResponsiveImage";

const BlogHeader = ({ heading, subHeading, topImage }) => {
  return (
    <>
      <h2 className="blog-heading">{heading}</h2>
      <h6 className="blog-sub-heading">{subHeading}</h6>
      <ResponsiveImage
        src={topImage}
        alt="Blog main image"
        className="blog-image"
        hash="LEHV6nWB2yk8pyo0adR*.7kCMdnj"
      />
    </>
  );
};

export default BlogHeader;
